/* eslint-disable no-unused-vars */
import React from "react";
import { useState, useEffect, useContext } from "react";
import Form from "react-bootstrap/Form";
import bg from "../img/bg.png";
import "./PageLogin.css";
import TopBar from "../components/TopBar";
import Footer from "../components/Footer";
import "../components/style.css";
import { Dropdown } from "react-bootstrap";
import BMIChartComponent from "../components/chart/BMIChartComponent";
import BloodPressureChartComponent from "../components/chart/BloodPressureChartComponent";
import ReportChartComponent from "../components/chart/ReportChartComponent";
import ManuTestRoud from "../components/ManuTestRoud";
import TableReport from "../components/TableReport";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  Title,
  ArcElement,
  LineController,
  Filler,
} from "chart.js";
// import { Table } from 'react-bootstrap';
// import { IoIosArrowDropdownCircle } from "react-icons/io";
import Container from "react-bootstrap/Container";
// import Nav from 'react-bootstrap/Nav';
import Navbar from "react-bootstrap/Navbar";
// import NavDropdown from 'react-bootstrap/NavDropdown';
// import Offcanvas from 'react-bootstrap/Offcanvas';
import {
  handleResizeDisplay,
  checkGroupsUser,
  getlocalStorage,
} from "../function/functionALL";
// import LoadingTable from '../components/LoadingTable'
// import { useLocation, } from "react-router-dom";
import { YearContext } from "../components/usecontext/YearContext"; // ระบุ path ที่ถูกต้องสำหรับ YearContext

ChartJS.register(
  Title,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  ArcElement,
  LineController,
  Filler,
  CategoryScale
);
require("moment/locale/th");

const PageResultGraph = () => {
  const [isStacked, setIsStacked] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { Token, DataToken_ } = getlocalStorage();
  const role = checkGroupsUser(DataToken_.groups);
  const role_openRole = role?.openRole;
  const [showChartBMI, setshowChartBMI] = useState(false);
  const [showChartBloodPressure, setshowChartBloodPressure] = useState(false);
  const [showChartReport, setshowChartReport] = useState(
    role_openRole?.RTAFPersonAdmin ? true : false
  );

  const { yearcurrent } = useContext(YearContext);

  const handleClickChartBMI = () => {
    setshowChartBMI((prev) => !prev);
    setshowChartBloodPressure(false);
    setshowChartReport(false);
  };

  const handleClickChartBloodPressure = () => {
    setshowChartBloodPressure((prev) => !prev);
    setshowChartBMI(false);
    setshowChartReport(false);
  };

  const handleClickChartReport = () => {
    setshowChartReport((prev) => !prev);
    setshowChartBloodPressure(false);
    setshowChartBMI(false);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    handleResizeDisplay(setIsStacked);
  }, []);

  return (
    <div>
      <TopBar />

      <Form>
        <div className="App login-box">
          <section
            style={{
              backgroundImage: `url(${bg})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 100%",
              backgroundSize: "cover",
              minHeight: "1180px",
            }}
          >
            <div className="rounded pb-2" style={{ padding: "68px 0 0 0" }}>
              <div className="row col-12 col-sm-12 ms-0 justify-content-center pt-4">
                <div className="col-sm-12 col-12">
                  <div
                    className="shadow-lg m-1 p-2 rounded min-w-50 justify-content-center"
                    style={{
                      backgroundColor: "rgb(247, 247, 247, 0.8)",
                      border: "1px solid  rgba(41, 43, 44, 0.1)",
                    }}
                  >
                    <div className="col-12 pt-2 text-center d-flex">
                      <div className="text-start col-1 col-md-4 p-0 h-100 ">
                        {[false].map((expand) => (
                          <Navbar key={expand} expand={expand}>
                            <Container fluid>
                              <Navbar.Toggle
                                className="d-none d-lg-block"
                                aria-controls={`offcanvasNavbar-expand-${expand}`}
                                style={{ fontSize: "14px" }}
                              >
                                {" "}
                                <span>ตัวเลือก : วงรอบปัจจุบัน</span>
                              </Navbar.Toggle>
                              <ManuTestRoud
                                expand={expand}
                                currentDateTime={yearcurrent}
                                isOpen={isOpen}
                                toggleMenu={toggleMenu}
                              />
                            </Container>
                          </Navbar>
                        ))}
                      </div>
                      <div
                        className=" col-10 col-md-4 card-title text-center fs-5 fs-3 py-1 "
                        style={{ color: "#000000" }}
                      >
                        <div className="fw-bold" style={{ fontSize: "21px" }}>
                          ผลการวิเคราะห์ระดับ ทอ.
                        </div>
                      </div>
                      <div
                        className=" col-1 col-md-4  "
                        style={{ color: "#000000" }}
                      ></div>
                    </div>
                    <div className="col-12 p-0 h-100 justify-content-center d-flex">
                      {[false].map((expand) => (
                        <Navbar key={expand} expand={expand}>
                          <Container fluid>
                            <Navbar.Toggle
                              className=" d-lg-none"
                              aria-controls={`offcanvasNavbar-expand-${expand}`}
                              style={{ fontSize: "12px" }}
                            >
                              {" "}
                              <span>ตัวเลือก : วงรอบปัจจุบัน</span>
                            </Navbar.Toggle>
                            <ManuTestRoud
                              expand={expand}
                              currentDateTime={yearcurrent}
                              isOpen={isOpen}
                              toggleMenu={toggleMenu}
                            />
                          </Container>
                        </Navbar>
                      ))}
                    </div>

                    <div className="row m-0  ">
                      <div className="col-lg-12  ">
                        <div className="row p-0 ">
                          <div className="card card-body p-1 m-1 col-12 text-center d-flex pb-1">
                            <div className="p-2  ">
                              ปีงบประมาณ {yearcurrent + 543}
                            </div>
                          </div>
                          <div className="text-center row col-12 m-0 p-1 ">
                            {role_openRole?.RTAFPersonAdmin ? (
                              <div
                                className=" col-12 mt-1 text-center text-lg-end"
                                style={{ padding: "0 0.8px 0 0.8px" }}
                              >
                                <Dropdown>
                                  <Dropdown.Toggle
                                    className="btn btn-outline-secondary"
                                    style={{
                                      fontSize: "14px",
                                      background: "none",
                                      border: "1px solid #666699",
                                      color: "#666699",
                                    }}
                                  >
                                    คลิกเพื่อเลือกกราฟ
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu className="w-auto">
                                    <Dropdown.Item
                                      onClick={handleClickChartBMI}
                                      style={{
                                        backgroundColor:
                                          showChartBMI === true
                                            ? "#d0d9ff"
                                            : "",
                                      }}
                                    >
                                      BMI
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={handleClickChartBloodPressure}
                                      style={{
                                        backgroundColor:
                                          showChartBloodPressure === true
                                            ? "#d0d9ff"
                                            : "",
                                      }}
                                    >
                                      ความดันโลหิต
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={handleClickChartReport}
                                      style={{
                                        backgroundColor:
                                          showChartReport === true
                                            ? "#d0d9ff"
                                            : "",
                                      }}
                                    >
                                      รายงานผลการทดสอบ
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            ) : (
                              ""
                            )}
                            {showChartBMI && (
                              <BMIChartComponent showChartBMI={showChartBMI} />
                            )}
                            {showChartBloodPressure && (
                              <BloodPressureChartComponent
                                showChartBloodPressure={showChartBloodPressure}
                              />
                            )}
                            {showChartReport && (
                              <ReportChartComponent
                                showChartReport={showChartReport}
                              />
                            )}
                          </div>

                          {role_openRole?.RTAFPersonAdmin ? (
                            <TableReport />
                          ) : (
                            ""
                          )}

                          <div className="p-2 pb-0 pb-1 ">
                            <div
                              className="card col-sm-12 col-xs-12 "
                              style={{
                                backgroundColor: "rgb(247, 247, 247, 0.68)",
                              }}
                            >
                              <div className="card-body rounded pt-3">
                                <div className="row pt-3 pt-md-2">
                                  <div
                                    className="col-12 col-md-12 col-lg-10 card-title fw-bold text-center text-md-start p-1 ps-md-2 d-md-flex justify-content-between"
                                    style={{ color: "#000000" }}
                                  >
                                    <span
                                      className="fw-bold col-12 col-md-6 col-lg-6 justify-content-end"
                                      style={{
                                        color: "#000000",
                                        fontSize: "20px",
                                      }}
                                    >
                                      <b>
                                        ลำดับผลคะแนนการทดสอบร่างกาย ระดับ ทอ.{" "}
                                      </b>
                                    </span>
                                  </div>

                                  <div className="col-12 col-md-12 col-lg-2 has-validation p-1 justify-contents-end">
                                    {/* <input type="number" name="seach" className="form-control " id="seach" placeholder="ค้นหา / Search"></input> */}
                                    เร็วๆนี้
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="p-2 pb-0 pb-1 ">
                            <div
                              className="card col-sm-12 col-xs-12 "
                              style={{
                                backgroundColor: "rgb(247, 247, 247, 0.68)",
                              }}
                            >
                              <div className="card-body rounded pt-3">
                                <div className="row pt-3 pt-md-2">
                                  <div
                                    className="col-12 col-md-12 col-lg-10 card-title fw-bold text-center text-md-start p-1 ps-md-2 d-md-flex justify-content-between"
                                    style={{ color: "#000000" }}
                                  >
                                    <span
                                      className="fw-bold col-12 col-md-6 col-lg-6 justify-content-end"
                                      style={{
                                        color: "#000000",
                                        fontSize: "20px",
                                      }}
                                    >
                                      <b>ลำดับผลคะแนนตามช่วงอายุระดับ ทอ. </b>
                                    </span>
                                  </div>

                                  <div className="col-12 col-md-12 col-lg-2 has-validation p-1 justify-contents-end">
                                    {/* <input type="number" name="seach" className="form-control " id="seach" placeholder="ค้นหา / Search"></input> */}{" "}
                                    เร็วๆนี้
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </Form>
    </div>
  );
};

export default PageResultGraph;
